import script from "./QuickpaySettingsSetupProviderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickpaySettingsSetupProviderModal.vue?vue&type=script&setup=true&lang=ts"

import "./QuickpaySettingsSetupProviderModal.vue?vue&type=style&index=0&id=7908543e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7908543e"]])

export default __exports__